<template>
	<div>
		<Panel class="quinielas-list" :title="titulo" :icon="icon" v-if="quinielas.length > 0" >
			<router-link :to="'/ver-quiniela/' + quiniela.id" class="panel-block" v-for="quiniela in quinielas" :key="quiniela.id">
				<div class="quiniela-item">
					<div class="atributo">
						<div class="valor truncate">{{quiniela.nombre}}</div>
						<div class="nombre">Nombre</div>
					</div>
					<div class="atributo">
						<div class="valor"><span class="tag is-capitalized" :class="classEstado(quiniela.estado)">{{ quiniela.status }}</span></div>
						<div class="nombre">Estado</div>
					</div>
					<div class="atributo">
							<div v-if="quiniela.tipo == 1" class="valor">
								<span class="icon"><font-awesome-icon icon="users"/></span>
								<span>{{ quiniela.jugadores_count }}</span>
							</div>
							<div v-else>
								<div class="valor">Parlay</div>
							</div>
						<div class="nombre">Tipo</div>
					</div>
					<div class="atributo is-hidden-mobile">
						<div class="valor">
							<span class="">
								<span class="icon"><font-awesome-icon icon="coins"/></span>
								<span>{{ quiniela.apuesta }}</span>
							</span>
						</div>
						<div class="nombre">Apuesta</div>
					</div>
					<div class="atributo is-hidden-mobile">
						<div class="valor">{{ quiniela.jugadores[0].pivot.aciertos }}</div>
						<div class="nombre">Aciertos</div>
					</div>
					<div class="atributo is-hidden-mobile">
						<div class="valor">{{ (quiniela.jugadores[0].pivot.ganada == 1) ? 'Si':'No' }}</div>
						<div class="nombre">Ganada</div>
					</div>
					<div class="atributo">
						<div class="valor truncate">{{ $timeago.format(new Date(quiniela.created_at),'es')}}</div>
						<div class="nombre">Creada</div>
					</div>
				</div>
			</router-link>
		</Panel>
		
	</div>
</template>

<script>
	import Panel from '@/components/Panel'
	import quniMixin from '@/mixins/quiniMixin'

	export default {
		components: { Panel },
		mixins: [quniMixin],
		props:{
			quinielas: {
				type: Array,
				required: true
			},
			user: {
				type: Object,
				required: true
			},
			titulo:{
				type: String,
				default: 'Lista de Quinielas'
			},
			icon: {
				type: String,
				default: 'check-square'
			}
		},
		name: 'QuinielasList',

		data() {
			return {

			};
		},
		methods:{
			
		}
	};
</script>

<style lang="css" scoped>
.quinielas-list{
	margin-bottom: 1em;
}
.quiniela-item{
	width: 100%;
	display: flex;
	overflow-x: hidden;
}
.quiniela-item .atributo:first-child{
	margin-left: 0;
}
.quiniela-item .atributo:last-child{
	margin-right: 0;
}
.quiniela-item .atributo{
	display: block;
	margin: 0 .5em;
	white-space: nowrap;
	width: 25%;
	min-width: 10%;
	text-align: left;
	overflow: hidden;
}
.quiniela-item .atributo .valor{
	font-size: .8em;
}
.quiniela-item .atributo .valor span.tag{
	font-size: .7em;
}
.quiniela-item .atributo .nombre{
	font-size: .5em;
}
</style>
